import {Modal} from 'antd';
import React from 'react';

const AppModal: React.FC<any> = ({
  visible,
  hideCloseIcon,
  onOk,
  onCancel,
  children,
  width,
}: any) => {
  return (
    <Modal
      maskClosable={hideCloseIcon === true}
      width={width}
      visible={visible}
      closeIcon={hideCloseIcon === true ? <></> : undefined}
      footer={null}
      onOk={onOk}
      onCancel={onCancel}>
      {children}
    </Modal>
  );
};

export default AppModal;
